import { ReactNode, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useSnackbarHelper } from "../../views/components/Snackbar";

interface RoleGuardProps {
  children: ReactNode;
  allowedRoles: string[];
}

const RoleGuard = ({ children, allowedRoles }: RoleGuardProps) => {
  const { user } = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const showSnackbar = useSnackbarHelper();

  useEffect(() => {
    if (user && !allowedRoles.includes(user.role)) {
      showSnackbar("You do not have permission to access this page.", "error");
      navigate("/cases");
    }
  }, [user, allowedRoles, navigate, showSnackbar]);

  if (!user || !allowedRoles.includes(user.role)) {
    return null;
  }

  return <>{children}</>;
};

export default RoleGuard;
